"use strict";
/*!
 *
 *  wiper-search.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var vue_1 = __importDefault(require("vue"));
var default_1 = /** @class */ (function () {
    function default_1() {
        if (document.querySelector('#WiperSearch')) {
            this.build();
        }
        ;
    }
    default_1.prototype.build = function () {
        new vue_1.default({
            el: '#WiperSearch',
            data: {
                maker: {
                    car_maker_alpha: '',
                    car_maker_kana: '',
                    is_worldauto: ''
                },
                init: {
                    id: '',
                    initial: ''
                },
                car: {
                    car_id: '',
                    model: ''
                },
                model: {
                    car_model_id: '',
                    model_year: ''
                },
                makerList: [],
                alphaList: [],
                carList: [],
                modelList: [],
                result: '',
                inited: false,
                isError: false,
                showAlpha: true
            },
            watch: {
                'maker': function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var res, res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.maker.car_maker_alpha !== '')) return [3 /*break*/, 5];
                                    if (!(this.maker.is_worldauto === '0')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, axios_1.default.get("/api/car.php?maker=" + this.maker.car_maker_alpha)];
                                case 1:
                                    res = _a.sent();
                                    this.alphaList = res.data;
                                    this.showAlpha = true;
                                    this.init = {
                                        id: '',
                                        initial: ''
                                    };
                                    this.car = {
                                        car_id: '',
                                        model: ''
                                    };
                                    this.model = {
                                        car_model_id: '',
                                        model_year: ''
                                    };
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, axios_1.default.get("/api/worldauto.php?maker=" + this.maker.car_maker_alpha)];
                                case 3:
                                    res = _a.sent();
                                    this.carList = res.data;
                                    this.showAlpha = false;
                                    this.car = {
                                        car_id: '',
                                        model: ''
                                    };
                                    this.model = {
                                        car_model_id: '',
                                        model_year: ''
                                    };
                                    _a.label = 4;
                                case 4:
                                    ;
                                    return [3 /*break*/, 6];
                                case 5:
                                    this.alphaList = [];
                                    _a.label = 6;
                                case 6:
                                    ;
                                    return [2 /*return*/];
                            }
                        });
                    });
                },
                'init': function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.init.id !== '')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, axios_1.default.get("/api/car.php?maker=" + this.maker.car_maker_alpha + "&init=" + this.init.id)];
                                case 1:
                                    res = _a.sent();
                                    this.carList = res.data;
                                    return [3 /*break*/, 3];
                                case 2:
                                    this.carList = [];
                                    _a.label = 3;
                                case 3:
                                    ;
                                    this.car = {
                                        car_id: '',
                                        model: ''
                                    };
                                    this.model = {
                                        car_model_id: '',
                                        model_year: ''
                                    };
                                    return [2 /*return*/];
                            }
                        });
                    });
                },
                'car': function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.car.car_id !== '')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, axios_1.default.get("/api/car.php?car=" + this.car.car_id)];
                                case 1:
                                    res = _a.sent();
                                    this.modelList = res.data;
                                    return [3 /*break*/, 3];
                                case 2:
                                    this.modelList = [];
                                    _a.label = 3;
                                case 3:
                                    ;
                                    this.model = {
                                        car_model_id: '',
                                        model_year: ''
                                    };
                                    return [2 /*return*/];
                            }
                        });
                    });
                },
                'model': function () {
                    if (this.model.car_model_id !== '') {
                        this.result = "/wiper/size/" + this.maker.car_maker_alpha + "/" + this.car.car_id + "/" + this.model.car_model_id;
                    }
                    else {
                        this.result = '';
                    }
                    ;
                }
            },
            mounted: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var res, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, axios_1.default.get('/api/maker.php')];
                            case 1:
                                res = _a.sent();
                                this.makerList = res.data;
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _a.sent();
                                this.makerList = [];
                                return [3 /*break*/, 3];
                            case 3:
                                ;
                                this.inited = true;
                                $('#WiperSearch .sw-Loading').fadeOut(300);
                                return [2 /*return*/];
                        }
                    });
                });
            },
            methods: {
                submit: function () {
                    if (this.result !== '') {
                        location.href = this.result;
                    }
                    else {
                        this.isError = true;
                    }
                    ;
                }
            }
        });
    };
    return default_1;
}());
exports.default = default_1;
